import API from '../../../../services/api';
import {BASE_HEIGHT, BASE_LINEHEIGHT} from '../../../../config';
import CharacterItem from './CharacterItem';
import ImageItem from './ImageItem';
import VideoItem from './VideoItem';
import TxtItem from './TxtItem';
import MusicItem from './MusicItem';

export const DEFAULT_TEXT_NAME = '双击编辑文字';

export const textList = [
    {
        text: '添加标题',
        size: 'large',
        name: DEFAULT_TEXT_NAME,
        h: (36 * BASE_LINEHEIGHT / BASE_HEIGHT).toFixed(3),
        styles: {
            fontSize: '36px',
            lineHeight: '48px',
            fontFamily: 'SiYuanHeiTi',
            color: 'rgba(51, 51, 51, 1)',
            textStrokeWidth: 1,
            WebkitTextStrokeWidth: 1,
            textStrokeColor: 'transparent',
            WebkitTextStrokeColor: 'transparent'
        }
    },
    {
        text: '添加副标题',
        size: 'middle',
        name: DEFAULT_TEXT_NAME,
        h: (20 * BASE_LINEHEIGHT / BASE_HEIGHT).toFixed(3),
        styles: {
            fontSize: '20px',
            lineHeight: '32px',
            fontFamily: 'SiYuanHeiTi',
            color: 'rgba(51, 51, 51, 1)',
            textStrokeWidth: 1,
            WebkitTextStrokeWidth: 1,
            textStrokeColor: 'transparent',
            WebkitTextStrokeColor: 'transparent'
        }
    },
    {
        text: '添加正文段落',
        size: 'small',
        name: DEFAULT_TEXT_NAME,
        h: (10 * BASE_LINEHEIGHT / BASE_HEIGHT).toFixed(3),
        styles: {
            fontSize: '10px',
            lineHeight: '22px',
            fontFamily: 'SiYuanHeiTi',
            color: 'rgba(51, 51, 51, 1)',
            textStrokeWidth: 1,
            WebkitTextStrokeWidth: 1,
            textStrokeColor: 'transparent',
            WebkitTextStrokeColor: 'transparent'
        }
    }
];

export default {
    character: {
        title: '我的',
        itemComponent: CharacterItem,
        listColumn: 4,
        listApi: API.GET_CHARACTER_LIB_LIST,
        uploadApi: API.UPLOAD_CHARACTER_FILE,
        dataFormatter: list => {
            return [].concat(list, {type: 'add'});
        }
    },
    pubCharacter: {
        title: '选择数字人',
        itemComponent: CharacterItem,
        listColumn: 4,
        listApi: API.GET_CHARACTER_LIB_LIST,
        uploadApi: API.UPLOAD_CHARACTER_FILE,
        dataFormatter: list => {
            return [].concat(list, {type: 'add'});
        }
    },
    bg: { // 背景图type 默认使用图片配置
        title: '请选择',
        itemComponent: ImageItem,
        listColumn: 3,
        listApi: API.GET_BG_LIB_LIST,
        uploadApi: API.UPLOAD_BG_IMG,
        delApi: API.DEL_BG_IMG,
        sizeLimit: 5, // 上传大小限制，单位M
        dataFormatter: list => {
            return [].concat({type: 'add'}, list);
        }
    },
    bg_img: {
        title: '请选择',
        itemComponent: ImageItem,
        listColumn: 3,
        listApi: API.GET_BG_LIB_LIST,
        uploadApi: API.UPLOAD_BG_IMG,
        delApi: API.DEL_BG_IMG,
        sizeLimit: 5, // 上传大小限制，单位M
        fileFilter: 'image/png,image/jpeg,image/jpg',
        dataFormatter: list => {
            return [].concat({type: 'add'}, list);
        }
    },
    ai_bg_img: {
        title: '请选择',
        itemComponent: ImageItem,
        listColumn: 3,
        listApi: API.GET_AI_BG_LIB_LIST,
        uploadApi: API.UPLOAD_BG_IMG,
        delApi: API.DEL_BG_IMG,
        sizeLimit: 5, // 上传大小限制，单位M
        fileFilter: 'image/png,image/jpeg,image/jpg',
        dataFormatter: list => {
            return [].concat({type: 'aigc'}, list);
        }
    },
    bg_video: {
        title: '请选择',
        itemComponent: VideoItem,
        listColumn: 3,
        listApi: API.GET_BG_VIDEO_LIB_LIST,
        uploadApi: API.UPLOAD_BG_VIDEO_IMG,
        delApi: API.DEL_BG_VIDEO,
        sizeLimit: 100, // 上传大小限制，单位M
        fileFilter: '.mp4,.mov,.avi',
        dataFormatter: list => {
            return [].concat({type: 'add'}, list);
        }
    },
    image: {
        title: '请选择',
        itemComponent: ImageItem,
        listColumn: 3,
        listApi: API.GET_PASTER_LIB_LIST,
        uploadApi: API.UPLOAD_PASTER_IMG,
        delApi: API.DEL_PASTER_IMG,
        sizeLimit: 5, // 上传大小限制，单位M
        dataFormatter: list => {
            return [].concat({type: 'add'}, list);
        }
    },
    txt: {
        title: '',
        listColumn: 1,
        itemComponent: TxtItem,
        dataFormatter: list => [...list]
    },
    solid: {
        title: '纯色背景'
    },
    gradient: {
        title: '渐变背景'
    },
    music: {
        title: '',
        itemComponent: MusicItem,
        listColumn: 1,
        listApi: API.GET_AUDIO_LIST,
        uploadApi: API.UPLOAD_AUDIO_FILE,
        delApi: API.DEL_AUDIO_FILE,
        fileFilter: '.mp3',
        dataFormatter: list => {
            return [].concat({type: 'add'}, {type: 'clear'}, list);
        }
    },
    music_lib: {
        title: '',
        itemComponent: MusicItem,
        listColumn: 1,
        listApi: API.GET_AUDIO_LIST,
        dataFormatter: list => {
            return [].concat({type: 'clear'}, list);
        }
    }
};

export const BG_TABS = [
    {
        name: '图片',
        key: 'bg_img'
    },
    {
        name: '视频',
        key: 'bg_video'
    },
    {
        name: '纯色',
        key: 'solid'
    },
    {
        name: '渐变',
        key: 'gradient'
    },
    {
        name: 'AI生图',
        key: 'ai_bg_img'
    }
];

export const MUSIC_TABS = [
    {
        name: '我的',
        key: 'music'
    }, {
        name: '公共库',
        key: 'music_lib'
    }
];
